import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import classnames from 'classnames';
import { Component, Fragment } from 'react';
import markdownToHTML from 'app/utils/markdownToHTML';
import AssistantSummaryItem from './AssistantSummaryItem';
export default class AssistantSummary extends Component {
    constructor(props) {
        super(props);
        this.toggleExpand = () => {
            const { showMore } = this.state;
            this.setState({
                showMore: !showMore,
            });
        };
        this.state = {
            showMore: false,
        };
    }
    renderMessage(message) {
        const { type } = message;
        if (type === 'conversation:conversational_assistant_menu') {
            return (_jsx(AssistantSummaryItem, { category: "Menu", message: markdownToHTML(message.chat_menu_text), action: `${message.author.name} clicked`, value: message.chat_menu_choice_label }, message.id));
        }
        if (type === 'conversation:conversational_assistant_input') {
            return (_jsx(AssistantSummaryItem, { category: "Input", message: markdownToHTML(message.chat_input_question), action: `${message.author.name} put in`, value: message.chat_input_answer }, message.id));
        }
        if (type === 'conversation:conversational_assistant_message') {
            return (_jsx(AssistantSummaryItem, { category: "Message", message: markdownToHTML(message.text) }, message.id));
        }
        return null;
    }
    render() {
        const { messages } = this.props;
        const { showMore } = this.state;
        if (messages.length === 0)
            return null;
        const rootClass = classnames('assistant-summary', {
            'assistant-summary--showMore': showMore,
        });
        const lastThree = messages.slice(-3);
        const hiddenMessages = messages.length > 3 ? messages.slice(0, messages.length - 3) : [];
        return (_jsxs("div", Object.assign({ className: rootClass }, { children: [_jsx("h2", Object.assign({ className: "assistant-summary__headline" }, { children: "Conversational Assistant" })), _jsxs("ul", Object.assign({ className: "assistant-summary__list" }, { children: [hiddenMessages.length > 0 && (_jsxs("ul", { children: [_jsxs("li", Object.assign({ className: classnames('assistant-summary-item', 'assistant-summary-item__expandable', {
                                        'assistant-summary-item__expanded': showMore,
                                    }) }, { children: [_jsx("div", Object.assign({ className: "assistant-summary-item__bullet assistant-summary-item__bullet--showMore" }, { children: _jsx("button", Object.assign({ onClick: this.toggleExpand, className: "assistant-summary-item__toggle" }, { children: _jsx(DixaIcon, { icon: "angle-right" }) })) })), _jsx("span", Object.assign({ className: "assistant-summary-item__text" }, { children: `${showMore
                                                ? 'Hide previous messages'
                                                : 'Show previous messages'}` }))] })), showMore && (_jsx(Fragment, { children: hiddenMessages.map((message) => this.renderMessage(message)) }))] })), lastThree.map((message) => this.renderMessage(message))] }))] })));
    }
}
